// Apple-only artwork (APPLE_ARTWORK_ONLY): where it is on, only Apple Music (mzstatic)
// artwork may be displayed. Any other cover url in an API response (i1.sndcdn.com,
// yt3.ggpht.com, scraped hosts) is nulled so the app's placeholders render instead,
// the artist hero band too. Erez 11-01: one switch, on for iOS/Android, off for
// web/desktop. Audio (sample_url) is untouched: it is already Apple-only.
// The switch is live (ec 11-01): GET /v1/config/lazy-resolve sends appleArtworkOnly.mode,
// NATIVE (phones only, the default) | ALL | OFF. Until the first answer the last-known mode
// (persisted) applies, and before any answer ever, the build-time value.
// CommonJS: main.js requires it directly; the shims and the renderer import it.
const APPLE_ART = /mzstatic\.com/i;
const ART_KEYS = new Set(['artworkUrl', 'artwork_url', 'artwork', 'coverFromTrack', 'cover_from_track', 'image']);

// '1'/'true'/'on' and '0'/'false'/'off' force it; anything else keeps the platform default
function resolveAppleArtworkOnly(envValue, platformDefault) {
    const v = String(envValue == null ? '' : envValue).trim().toLowerCase();
    if (['1', 'true', 'on', 'yes'].includes(v)) return true;
    if (['0', 'false', 'off', 'no'].includes(v)) return false;
    return !!platformDefault;
}

const MODES = new Set(['NATIVE', 'ALL', 'OFF']);
const LS_KEY = 'appleArtwork:mode';
const storage = () => { try { return typeof localStorage !== 'undefined' ? localStorage : null; } catch (_) { return null; } };
let liveMode = (() => { try { const v = storage()?.getItem(LS_KEY); return MODES.has(v) ? v : null; } catch (_) { return null; } })();

// the server's mode; anything unknown keeps the current one
function setAppleArtworkMode(mode) {
    const v = String(mode || '').toUpperCase();
    if (!MODES.has(v)) return liveMode;
    liveMode = v;
    try { storage()?.setItem(LS_KEY, v); } catch (_) { /* non-fatal */ }
    return liveMode;
}
const getAppleArtworkMode = () => liveMode;

// is it on here, now: the live mode when known, else the build-time value
function appleArtworkOnlyNow(isNativePlatform, buildFallback) {
    if (liveMode === 'ALL') return true;
    if (liveMode === 'OFF') return false;
    if (liveMode === 'NATIVE') return !!isNativePlatform;
    return !!buildFallback;
}

function stripNonAppleArtwork(node, depth = 0) {
    if (!node || typeof node !== 'object' || depth > 8) return node;
    if (Array.isArray(node)) { for (const v of node) stripNonAppleArtwork(v, depth + 1); return node; }
    for (const k in node) {
        const v = node[k];
        if (typeof v === 'string') {
            if (ART_KEYS.has(k) && /^https?:\/\//i.test(v) && !APPLE_ART.test(v)) node[k] = null;
        } else if (k === 'heroCover' && v && typeof v === 'object') {
            // the artist hero band ({url, source, focus}) and its picture list ([{url, source}])
            if (!APPLE_ART.test(String(v.url || ''))) node[k] = null;
        } else if (k === 'covers' && Array.isArray(v)) {
            node[k] = v.filter((c) => !c || typeof c !== 'object' || APPLE_ART.test(String(c.url || '')));
        } else if (v && typeof v === 'object') {
            stripNonAppleArtwork(v, depth + 1);
        }
    }
    // the server may send a face picture as artworkUrl with the Apple one beside it: show the Apple one
    if (node.artworkUrl == null && typeof node.appleArtworkUrl === 'string' && APPLE_ART.test(node.appleArtworkUrl)) node.artworkUrl = node.appleArtworkUrl;
    return node;
}

module.exports = { APPLE_ART, resolveAppleArtworkOnly, setAppleArtworkMode, getAppleArtworkMode, appleArtworkOnlyNow, stripNonAppleArtwork };
